import * as React from 'react';
import { Check } from 'lucide-react';
import { cn } from '@/lib/utils';

export interface AuthCheckboxProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: React.ReactNode;
}

const AuthCheckbox = React.forwardRef<HTMLInputElement, AuthCheckboxProps>(
  ({ className, label, id, checked, onChange, ...props }, ref) => {
    return (
      <label
        htmlFor={id}
        className={cn('flex cursor-pointer items-start gap-3', className)}
      >
        <div className="relative flex-shrink-0">
          <input
            type="checkbox"
            id={id}
            ref={ref}
            checked={checked}
            onChange={onChange}
            className="sr-only"
            {...props}
          />
          <div
            className={cn(
              'flex h-6 w-6 items-center justify-center rounded-md border-2 transition-colors',
              checked
                ? 'border-[#2197f1] bg-[#2197f1]'
                : 'border-[#2197f1] bg-white'
            )}
          >
            {checked && <Check className="h-4 w-4 text-white" strokeWidth={3} />}
          </div>
        </div>
        {label && (
          <span className="text-[14px] leading-[1.4] text-[#565858]">
            {label}
          </span>
        )}
      </label>
    );
  }
);
AuthCheckbox.displayName = 'AuthCheckbox';

export { AuthCheckbox };
